import { useState } from 'react'

import type { ICompany, TCompanyVerificationMethods } from '../types/company'
import { ReceiveCodeMethodEnum } from '../types/company'
import { createGenericContext } from './generic-context'

interface WorkspaceSetupContextProps {
  allowableVerificationMethods: TCompanyVerificationMethods | null
  companyDetails: ICompany | null
  companyIdentifierType: string
  companyIdentifierValue: string
  emailVerificationMethod: { type: string; value: string } | null
  receiveCodeMethod: ReceiveCodeMethodEnum
  setAllowableVerificationMethods: (methods: TCompanyVerificationMethods) => void
  setCompanyDetails: (details: ICompany) => void
  setCompanyIdentifierType: (type: string) => void
  setCompanyIdentifierValue: (value: string) => void
  setEmailVerificationMethod: (method: { type: string; value: string }) => void
  setReceiveCodeMethod: (method: ReceiveCodeMethodEnum) => void
  setStep: (step: number) => void
  setVerificationMethod: (method: { type: string; value: string }) => void

  step: number
  verificationMethod: { type: string; value: string } | null
}

const [useWorkspaceSetup, WorkspaceSetupContextProvider] = createGenericContext<WorkspaceSetupContextProps>()

const WorkspaceSetupProvider = ({ children }: { children: React.ReactNode }) => {
  const [step, setStep] = useState(2)
  const [companyIdentifierType, setCompanyIdentifierType] = useState('DOT')
  const [companyIdentifierValue, setCompanyIdentifierValue] = useState('')
  /** The company matching the DOT or MC */
  const [companyDetails, setCompanyDetails] = useState<ICompany | null>(null)
  const [allowableVerificationMethods, setAllowableVerificationMethods] = useState<TCompanyVerificationMethods | null>(
    null
  )

  const [verificationMethod, setVerificationMethod] = useState<{ type: string; value: string } | null>(null)
  const [receiveCodeMethod, setReceiveCodeMethod] = useState(ReceiveCodeMethodEnum.SMS)

  const [emailVerificationMethod, setEmailVerificationMethod] = useState<{ type: string; value: string } | null>(null)

  const value = {
    allowableVerificationMethods,
    companyDetails,
    companyIdentifierType,
    companyIdentifierValue,
    emailVerificationMethod,
    receiveCodeMethod,
    setAllowableVerificationMethods,
    setCompanyDetails,
    setCompanyIdentifierType,
    setCompanyIdentifierValue,
    setEmailVerificationMethod,
    setReceiveCodeMethod,
    setStep,
    setVerificationMethod,
    step,
    verificationMethod
  }

  return <WorkspaceSetupContextProvider value={value}>{children}</WorkspaceSetupContextProvider>
}

export { useWorkspaceSetup, WorkspaceSetupProvider }
